module.exports = __webpack_public_path__ + "img/thumb_audio.6b992c55.svg";